const Section04 = ({
  contentsRef,
}: {
  contentsRef: React.RefObject<HTMLDivElement>;
}) => {
  return (
    <section className='section02 w-full mb-[50px]' ref={contentsRef}>
      <div className='w-full pt-[30px] px-[20px] relative'>
        <h3 className='text-[#2F46B8] font-[600] mb-[12px] text-[14px]'>
          협회장 인사말
        </h3>
        <p className='max-w-[275px] text-[16px] leading-[25.6px] font-[600] text-[#1C1F35] whitespace-pre-line break-keep'>
          “신선한 기획, 훌륭한 제품, 뛰어난 마케팅도 결국 영업이 있어야 꽃을
          피울 수 있습니다.”
        </p>
        <div className='w-full mt-[30px] py-[24px] px-[20px] relative '>
          <img
            src='/imgs/m_section02_bg.png'
            alt='인사말 뒷 배경'
            className='w-full h-full object-cover rounded-[10px] absolute top-0 left-0'
          />
          <div className='relative z-[1] flex flex-col justify-start items-start gap-[12px] text-[15px] leading-[24px] tracking-[-0.38px] font-[400] pb-[60px]'>
            <p className='whitespace-pre-line break-keep'>
              각국 대통령분들도 세일즈맨이 되어 전 세계를 누비고 있는 지금은
              바야흐로 세일즈의 시대입니다. 과거 '판매직'이란 단어가
              '영업직'으로, '영업직'이란 단어가 '세일즈'라는 단어로 바뀌었음에도
              불구하고 유독 우리나라에서만큼은 영업직에 대해 곱지 않은 시선을
              보내는 경향이 있습니다.
            </p>
            <p className='whitespace-pre-line break-keep'>
              ‘영업’은 심리, 화술, 인간관계, 자기관리, 지식습득, 인문학 등 삶의
              결정체이며{' '}
              <span className='relative inline bg-[#D6DDFF] box-decoration-clone font-[500] whitespace-pre-line break-keep'>
                삶의 일부를 가르치고 배울 수 있는 학문의 영역
              </span>
              이라고 생각합니다. 또한 '경제인'이란 합리적인 경제 행위를 하는
              사람을 일컫기 때문에 결국 한국영업경제인협회는 특정 계층이 아닌 전
              국민을 아우른다고 볼 수 있습니다.
            </p>
            <p className='whitespace-pre-line break-keep'>
              우리 한국영업경제인협회는 회원 간의 정보교류 및 유·무형 상품의
              거래를 위한 건전한 환경을 조성하여 회원님들의{' '}
              <span className='relative inline bg-[#D6DDFF] box-decoration-clone font-[500] whitespace-pre-line break-keep'>
                영업·경제 활동을 독려
              </span>
              하고{' '}
              <span className='relative inline bg-[#D6DDFF] box-decoration-clone font-[500] whitespace-pre-line break-keep'>
                영업에 대한 인식 변화
              </span>
              를 이끌어내는 데 최선을 다하겠습니다.
            </p>
            <p className='pt-[8px]'>감사합니다.</p>
          </div>
          <div className='inline-flex justify-end items-center absolute bottom-[20px] right-[14px] gap-[10px]'>
            <span className='text-[14px] leading-[22.4px] font-[400] text-[#555555]'>
              회장
            </span>
            <img
              src='/imgs/greeting_sign.png'
              alt='대표자 사인'
              className='h-[44px] object-contain'
            />
          </div>
        </div>
      </div>
    </section>
  );
};
export default Section04;
